module.exports = __webpack_public_path__ + "img/10.d1a35449.png";